import { useNavigate } from 'react-router-dom'
import { useAuth0 } from "@auth0/auth0-react"
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { SaveIcon } from '../../images/Icons'
import { 
    storeEventTaskAsync, 
    selectCurrentEventTaskStatus
} from './currentEventTaskSlice'
import '../../App.css'
import { sanitizeEmail } from '../../utils/emailUtils'

export function SaveEventTaskButton() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentEventTaskStatus = useAppSelector(selectCurrentEventTaskStatus)

    return (
        <div className='iconButton' onClick={async () => {
            if (isAuthenticated && user?.email) { 
                
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                    dispatch(storeEventTaskAsync( { 
                        token: accessToken,
                        userEmail: sanitizeEmail(user?.email)
                        }))
                    if (currentEventTaskStatus === 'idle') {
                        navigate(-1)
                    } else {
                        alert (`Not expected status '${ currentEventTaskStatus }'`)
                    }
                
            }
        }}>
            <SaveIcon />
        </div>
    )
}